import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'hmt-validation-message',
    templateUrl: './validation-message.component.html',
    styleUrls: ['./validation-message.component.scss'],
    standalone: false
})
export class ValidationMessageComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ValidationMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string
    }
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
